module.exports = __webpack_public_path__ + "img/Still-Thinking-2-mobile.1d26488f.png";